// extracted by mini-css-extract-plugin
module.exports = {"line":"Footer_line__I7jkY","footer":"Footer_footer__V4f5Q","listContainer":"Footer_listContainer__8YCbS"};